import WebHttpService from '@shining3d/http-service';
import { XlMessage } from '@shining3d/ui-components';
import _get from 'lodash/get';
import { VueCookieNext } from 'vue-cookie-next';
import router from '@/router';
const loginOut = () => {
	XlMessage({
		message: _get( errMapCommon, 'landExpiration' ),
		type: 'error'
	});
	VueCookieNext.removeCookie( 'token' );
	VueCookieNext.removeCookie( 'user_id' );
	VueCookieNext.removeCookie( 'uTitle' );
	VueCookieNext.removeCookie( 'dentalxToken' );
	// 医生工作台处理方法
	if ( !VueCookieNext.getCookie( 'token' )) {
		// 云平台处理，token存在跳过，入参路径>oem+当前页面路径
		const redirectToUrl = router.resolve({ name: 'oemDomainPage', params: { oemDomain: VueCookieNext.getCookie( 'oemURL' ) || 'index' } }).href + window.location.search;
		if ( window.location.href !== redirectToUrl ) {
			window.location.href = redirectToUrl;
		}
	} else {
		console.log( 'token未清除' );
	}
};
// 错误信息处理
const errMapCommon = _get( window, 'app.i18n.@shining3d/app.apiErr.common' );
const errMap = _get( window, 'app.i18n.@shining3d/xl-design-order.apiErr' );
const errMessage = ( val ) => {
	XlMessage({ type: 'error', message: val });
};

const httpService = new WebHttpService({ baseUrl: window.app.baseURL, errMap, errMapCommon, loginOut, errMessage, cookiePrefix: _get( window, 'app.global.cookies.env', '' ) });
export default httpService;